package nacholab.supplies.ui.theme

import com.varabyte.kobweb.compose.ui.graphics.Color
import org.jetbrains.compose.web.css.deg

object MainColors {
    val LLA_BLUE = Color.rgb(35,44,83)
    val WHITE = Color.rgb(255, 255, 255)
    val YELLOW = Color.rgb(207,207,0)
    val GREEN = Color.rgb(166, 207, 0)
    val DARK_CYAN = Color.rgb(41, 88, 105)
    val LIGHT_CYAN = Color.rgb(0, 171, 196)
    val DARK_GRAY = Color.rgb(42, 42, 42)
    val BLACK = Color.rgb(0,0,0)
    val RED = Color.rgb(192,0,0)
    val SHEET_GRAY = Color.rgb(225,225,225)
    val BLACK_TRANSPARENT_128 = Color.rgba(0,0,0,128)

    val HUE_ROTATION_FROM_SEPIA_GREEEN = 15.deg
}